import CryptoJS from 'crypto-js';
import Swal from 'sweetalert2';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';


export const encryptData = (string) => {
    let encrypted = CryptoJS.AES.encrypt(string, process.env.REACT_APP_ENCRYPTION_SECRET_KEY).toString();
    let wordArray = CryptoJS.enc.Base64.parse(encrypted);
    return CryptoJS.enc.Hex.stringify(wordArray);
}

export const decryptData = (string) => {
    if (string !== "") {
        let wordArray = CryptoJS.enc.Hex.parse(string);
        let toDecrypt = CryptoJS.enc.Base64.stringify(wordArray);
        return CryptoJS.AES.decrypt(toDecrypt, process.env.REACT_APP_ENCRYPTION_SECRET_KEY).toString(CryptoJS.enc.Utf8);
    } else {
        return "";
    }

}
export const OpenSwal = (status, message) => {
    if (status === "Token_error") {
        const pathname = window.location.pathname;
        if (pathname !== '/') {
            sessionStorage.setItem('session_token_url_path', pathname);
            Swal.fire({ title: 'Error!', text: "Token Expired Please login again", icon: 'error', confirmButtonText: 'Login' }).then((result) => {
                if (result.isConfirmed) {
                    const navigate = message;
                    navigate('/');
                }
            });
        }

    } else if (status === "Axios_error") {
        Swal.fire({
            title: 'Error!',
            text: message,
            icon: 'error',
            confirmButtonText: 'Call ITI',
            showCancelButton: true,
            cancelButtonColor: '#f34343',
            cancelButtonText: 'Dismiss',
            reverseButtons: true,
            focusCancel: true
        }).then((result) => {
            if (result.isConfirmed) {
                let iti_support_number = process.env.REACT_APP_ASSIGN_ACCEPT_SUPPORT_CALL_NUMBER
                window.location.href = 'tel:' + iti_support_number;
            }
        });
    }

}

export const GoogleMapNavigation = (props) => {
    let gmap_url = 'https://www.google.com/maps/dir/?api=1&origin=' + props.latitude + ',' + props.longitude + '&destination=' + props.address + '&dir_action=navigate';
    console.log('Opening Url : ' + gmap_url);
    window.open(gmap_url, '_blank');

}

export const notistackSnakebar = (enqueueSnackbar, closeSnackbar, dataObj) => {

    enqueueSnackbar(dataObj.message, {
        variant: dataObj.variant, preventDuplicate: (dataObj.preventDuplicate) ? true : false, persist: (dataObj.persist) ? true : false, anchorOrigin: (dataObj.anchorOrigin === 'bottom') ? { vertical: 'bottom', horizontal: 'right' } : { vertical: 'top', horizontal: 'right' }, action: (snackbarId) => {
            return (
                <IconButton onClick={() => closeSnackbar(snackbarId)}>
                    <CloseIcon />
                </IconButton>
            )
        }
    });


}


export function validateMobileNumber(event) {
    const keyCode = event.keyCode || event.which;
    if (keyCode !== 8 && keyCode !== 187 && keyCode !== 189) {
        let keyValue = String.fromCharCode(keyCode);
        let reg = new RegExp('^[0-9]+$');
        if (!reg.test(keyValue)) {
            event.preventDefault();
        }
    }
}


export const ValidateNumberInput = (event) => {
    const keyCode = event.keyCode || event.which;
    if (keyCode !== 8 && keyCode !== 190 && keyCode !== 188) {
        let keyValue = String.fromCharCode(keyCode);
        let reg = new RegExp('^[0-9]+$');

        if (!reg.test(keyValue)) {
            event.preventDefault();
        }
    }
}

export const getCurrentGeolocation = async () => {
    let return_position = {}
    if ("geolocation" in navigator) {
        return_position = new Promise((resolve, reject) => {
            navigator.geolocation.getCurrentPosition(
                position => resolve({
                    status: true,
                    longitude: position.coords.longitude,
                    latitude: position.coords.latitude
                }),
                error => resolve({
                    status: false,
                    message: error.message
                })
            )
        });
    } else {
        return_position = {
            status: false,
            message: "Geolocation is Not Supported in your browser",
        }
    }
    return return_position;
}